<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :visible.sync="visible"
    :show-close="true"
    :title="username+' '+title"
    :showIcon="false"
    showCancelBtn
    destroy-on-close
    append-to-body
    width="40%"
    @on-confirm="confirmHandler"
  >
  <tg-form-table
      :data.sync="tableData"
      :columns="columns"
      :columnWidth="250"
      :cellWidth="400"
    >
    <template slot="limit_bet_value" slot-scope="scope">
      <el-input
        :placeholder="$t('component.form.input.placeholder.number')"
        v-model="tableData[scope.column.name]"
        class="tg-input col-6"
        size="small"
        type="number"
        clearable
      ></el-input>
    </template>
  </tg-form-table>
  <div class="board--limit-bet">
    <span class="tip">
      {{ $t('component.dialog.bet_limit.tip') }}
    </span>
  </div>

  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";
import TgFormTable from "@/components/table/TgFormTable";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
    TgFormTable,
  },
  data() {
    return {
      visible: false,
      tableData:[],
      columns:[{
        "name": "limit_bet_value",
        "title": this.$t("column.limit_bet_value"),
        "label": this.$t("column.limit_bet_value"),
        "slot": "limit_bet_value",
        "headerSlot": "limit_bet_value",
        "width": 150,
      }]
    };
  },
  props: {
    value: Number,
    username: String,
    title: String,
  },
  methods: {
    confirmHandler() {
      this.$emit(
        "confirm",
        this.tableData.limit_bet_value,
        this.username,
      );
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>